import React, { useRef, useState, useEffect } from 'react';
import { render } from 'react-dom';

import Slider from 'react-slick';

interface ICarouselImageItem {
  imageUrl: string;
  alt?: string
  link?: string;
  target?: string;
};

interface ICorouselSettings{
  size?: string;
}

declare global{
  interface Window { currentCarousel: string; }
}
const carouselId: string = window?.currentCarousel;

const ImageCarousel:React.FunctionComponent<ICorouselSettings> = () =>  {
    const settings = {
      dots: true,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 5000,
      style: {padding: '0 20px'}

    };
    
    if (carouselId && window[carouselId] && window[carouselId]['images']) {
      var carouselData: ICarouselImageItem[] = window[carouselId]['images'] as ICarouselImageItem[];
      const maxWidth = window[carouselId]['maxwidth'];
      return (
        <div id={`carousel-container${carouselId}`} style={{margin:'0 auto', maxWidth: `min(${maxWidth}px, 80vw)`}}>
          <Slider {...settings} >
              {
              carouselData?.map((item, i) => 
                <div key={i}>
                  <img
                    src={item.imageUrl}
                    alt={item?.alt}
                    style={{objectFit:'contain', margin:'0 auto'}}
                  />
                </div>
              )}
              </Slider>
          </div>
      );
    }
    return null;
        
  }

  if (window?.currentCarousel)
    render(<ImageCarousel/>, document.getElementById(carouselId));
